import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, ShimmerBox, Text, useResponsive } from '@common-fe/common-fe';

import { ServicesPaymentOrder } from '@/modules/UseMyMoney/components';
import { AccountOrder } from '@/modules/UseMyMoney/queries';

import AiSuggestedServicesListItem from './AiSuggestedServicesListItem';

interface Props {
  searchString?: string;
  aiSuggestedAccountOrdersArrays?: AccountOrder[][];
  isAiSuggestedAccountOrdersLoading?: boolean;
  handleChangeService: (serviceId?: string) => void;
}

const AiSuggestedServicesList: React.FC<Props> = ({ searchString, aiSuggestedAccountOrdersArrays, isAiSuggestedAccountOrdersLoading, handleChangeService }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  if (isAiSuggestedAccountOrdersLoading) {
    return (
      <Box data-testId="ai-suggested-services_loader" margin={{ top: 'spacing12' }}>
        <ShimmerBox height="50px" />
        <ShimmerBox margin={{ top: 'spacing8' }} height="50px" />
        <ShimmerBox margin={{ top: 'spacing8' }} height="50px" />
      </Box>
    );
  }

  if (!aiSuggestedAccountOrdersArrays?.length && searchString && searchString?.length >= 3) {
    return (
      <Box
        data-testId="ai-suggested-services_empty-state"
        margin={{ top: 'spacing12' }}
        pad="spacing16"
        background="missingContainer"
        round="container1Round"
      >
        <Text>
          {t('No results found. Try describing your service in a different way.')}
        </Text>
      </Box>
    );
  }

  if (!aiSuggestedAccountOrdersArrays?.length) {
    return null;
  }

  return (
    <Box data-testId="ai-suggested-services_list-wrapper" margin={{ top: 'spacing12' }}>
      <Text>
        {t('Based on your description, we suggest:')}
      </Text>
      <Box margin={{ top: 'spacing12' }} gap="spacing16">
        {aiSuggestedAccountOrdersArrays?.map((accountOrders, index) => (
          <Box key={index}>
            <ServicesPaymentOrder accountOrders={accountOrders} isMobile={isMobile} />
            {accountOrders?.map((accountOrder) => accountOrder?.services?.map((service) => (
              <AiSuggestedServicesListItem
                key={service?.id}
                service={service}
                handleChangeService={handleChangeService}
              />
            )))}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AiSuggestedServicesList;
